export default __webpack_public_path__ + "locales/vi/Settings.json?hash=038020ab8367d41ad4841db6caf0ff03";